import { render, staticRenderFns } from "./CustomerDetailsCardContact.vue?vue&type=template&id=178936a5&"
import script from "./CustomerDetailsCardContact.vue?vue&type=script&lang=ts&"
export * from "./CustomerDetailsCardContact.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports